/* Animate once on entry, for less than five seconds. Variant re-renders reconnect automatically. */
(function () {
  'use strict';
  if (!('customElements' in window) || customElements.get('triops-sale-price')) return;
  class TriopsSalePrice extends HTMLElement {
    connectedCallback() {
      if (this._setup) return;
      this._setup = true;
      this._motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._onMotionChange = () => {
        if (this._motion.matches) {
          this.classList.remove('is-animating');
          window.clearTimeout(this._timer);
        }
      };
      if (this._motion.addEventListener) this._motion.addEventListener('change', this._onMotionChange);
      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.4)) {
            this._play();
            this._observer.disconnect();
          }
        }, { threshold: 0.4 });
        this._observer.observe(this);
      } else {
        this._play();
      }
    }
    _play() {
      if (this._played || this._motion.matches) return;
      this._played = true;
      this.classList.add('is-animating');
      this._timer = window.setTimeout(() => this.classList.remove('is-animating'), 4850);
    }
    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
      if (this._motion && this._motion.removeEventListener) this._motion.removeEventListener('change', this._onMotionChange);
      window.clearTimeout(this._timer);
      this.classList.remove('is-animating');
      this._setup = false;
    }
  }
  customElements.define('triops-sale-price', TriopsSalePrice);
}());
